import React, { useState, useEffect } from "react";
import { Brand, Button, Field, Status, Empty } from "./ui";
import { api, demo } from "./data";
import { money, date } from "./domain";
import { receiptPNG } from "./receipts";
export function Tracking({ data, route, run }) {
  const token = route.split("/")[1];
  const review = route.startsWith("#review");
  const [order, setOrder] = useState(null),
    [error, setError] = useState(""),
    [loading, setLoading] = useState(true),
    [rating, setRating] = useState(5),
    [text, setText] = useState(""),
    [sent, setSent] = useState(false),
    [busy, setBusy] = useState(false);
  useEffect(() => {
    if (review) {
      setLoading(false);
      return;
    }
    if (demo) {
      setOrder(data?.orders.find((o) => (o.tracking_token || o.id) === token));
      setLoading(false);
      return;
    }
    fetch(`/api/order?token=${encodeURIComponent(token)}`)
      .then(async (r) => {
        const b = await r.json();
        if (!r.ok) throw new Error(b.error);
        setOrder(b);
      })
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, [token]);
  async function sendReview(e) {
    e.preventDefault();
    setBusy(true);
    try {
      if (demo) {
        const d = JSON.parse(localStorage.getItem("dilo-demo-v1"));
        const o = d.orders.find((o) => o.review_token === token);
        if (!o || o.status !== "Entregado" || o.review)
          throw new Error("Este pedido no admite una nueva reseña.");
        o.review = { rating, text, date: new Date().toISOString() };
        localStorage.setItem("dilo-demo-v1", JSON.stringify(d));
        window.dispatchEvent(new Event("dilo-change"));
      } else {
        const r = await fetch("/api/review", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ token, rating, text }),
        });
        const b = await r.json();
        if (!r.ok) throw new Error(b.error);
      }
      setSent(true);
    } catch (e) {
      setError(e.message);
    } finally {
      setBusy(false);
    }
  }
  async function proof(file) {
    if (!file) return;
    setBusy(true);
    try {
      if (demo) {
        const url = await api.upload(file, data.store.id, true);
        await api.attachReceipt(order.id, url);
      } else {
        const f = new FormData();
        f.set("file", file);
        f.set("token", token);
        const r = await fetch("/api/proof", { method: "POST", body: f });
        const b = await r.json();
        if (!r.ok) throw new Error(b.error);
      }
      setOrder({ ...order, has_receipt: true });
      setError("");
    } catch (e) {
      setError(e.message);
    } finally {
      setBusy(false);
    }
  }
  return (
    <main style={{ maxWidth: 760, padding: "35px 20px", margin: "auto" }}>
      <div
        className="flex"
        style={{ justifyContent: "space-between", marginBottom: 30 }}
      >
        <Brand />
        <a href="/" className="text-button">
          Volver a la tienda
        </a>
      </div>
      {review ? (
        <div className="card">
          <h1>{sent ? "¡Gracias por tu reseña!" : "¿Cómo fue tu compra?"}</h1>
          {!sent && (
            <form onSubmit={sendReview}>
              <p>Tu experiencia nos ayuda a mejorar.</p>
              <div className="review-stars">
                {[1, 2, 3, 4, 5].map((n) => (
                  <button
                    type="button"
                    key={n}
                    aria-label={`${n} estrellas`}
                    onClick={() => setRating(n)}
                  >
                    {n <= rating ? "★" : "☆"}
                  </button>
                ))}
              </div>
              <Field label="Cuéntanos tu experiencia">
                <textarea
                  required
                  maxLength={1000}
                  value={text}
                  onChange={(e) => setText(e.target.value)}
                />
              </Field>
              <Button className="full" disabled={busy}>
                Enviar reseña
              </Button>
            </form>
          )}
        </div>
      ) : loading ? (
        <p>Cargando tu pedido…</p>
      ) : order ? (
        <div className="card">
          <div className="card-head">
            <h1 style={{ fontSize: "1.6rem", margin: 0 }}>
              Tu pedido {order.number}
            </h1>
            <Status value={order.status} />
          </div>
          <p>
            Hola, {order.customer_name}. Aquí puedes consultar el avance de tu
            compra.
          </p>
          <small>{date(order.created_at)}</small>
          {order.items.map((i, n) => (
            <div className="detail-item" key={n}>
              <div>
                <strong>
                  {i.quantity} × {i.name}
                </strong>
                <small>
                  {i.color} · {i.sku}
                </small>
              </div>
              <strong>{money(i.total)}</strong>
            </div>
          ))}
          <div className="totals">
            <p>
              Subtotal <span>{money(order.subtotal)}</span>
            </p>
            <p>
              Envío <span>{money(order.shipping)}</span>
            </p>
            <h3>
              Total <span>{money(order.total)}</span>
            </h3>
          </div>
          <div className="info-grid">
            <div>
              <h3>Entrega</h3>
              <p>
                {order.delivery === "pickup"
                  ? "Recojo en tienda"
                  : order.address}
              </p>
            </div>
            <div>
              <h3>Pago por {order.payment}</h3>
              <p className="pre-line">
                {order.payment === "Yape"
                  ? data?.store?.yape
                  : order.payment === "Plin"
                    ? data?.store?.plin
                    : data?.store?.bank}
              </p>
            </div>
          </div>
          {["Pendiente", "Prepedido", "Aceptado"].includes(order.status) && (
            <div className="notice">
              {order.has_receipt ? (
                "Recibimos tu comprobante. La tienda verificará el abono."
              ) : (
                <>
                  <p>
                    Después de pagar, puedes adjuntar tu comprobante. Tu pedido
                    cambiará a Pagado cuando la tienda lo verifique.
                  </p>
                  <input
                    aria-label="Adjuntar comprobante de pago"
                    type="file"
                    disabled={busy}
                    accept="image/jpeg,image/png,image/webp,application/pdf"
                    onChange={(e) => proof(e.target.files[0])}
                  />
                </>
              )}
            </div>
          )}
          <div className="actions" style={{ marginTop: 20 }}>
            <Button
              kind="outline"
              onClick={() =>
                receiptPNG(order, data?.store || { name: "Dilo Shop" })
              }
            >
              Descargar recibo PNG
            </Button>
            {order.status === "Entregado" && !order.review && (
              <a className="btn" href={`#review/${order.review_token}`}>
                Dejar una reseña
              </a>
            )}
          </div>
        </div>
      ) : (
        <Empty title="No se encontró el pedido" />
      )}
      {error && (
        <p className="error-text" role="alert">
          {error}
        </p>
      )}
    </main>
  );
}
